"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[829],{

/***/ 89915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89799);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_commons_colours__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56116);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56158);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90471);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76417);
/* harmony import */ var _LaunchDarkly__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56998);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var LinkWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU).withConfig({
    componentId: "sc-3c9b49d1-0"
})(_templateObject(), function(_) {
    return (0,_lendi_ui_commons_colours__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("interaction", "main");
});
var Disclaimer = function(param) {
    var _alignment = param.alignment, alignment = _alignment === void 0 ? "center" : _alignment, buttonText = param.buttonText;
    var tracking = react__WEBPACK_IMPORTED_MODULE_4__.useContext(_LaunchDarkly__WEBPACK_IMPORTED_MODULE_6__/* .LDContext */ .G).tracking;
    var eventTracking = (tracking || {}).eventTracking;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)([
        "PRIVACY_POLICY_LINK",
        "SITE_NAME"
    ]), 2), privacyPolicyLink = ref[0], siteName = ref[1];
    var handlePrivacyPolicyClick = function() {
        eventTracking === null || eventTracking === void 0 ? void 0 : eventTracking.trackAuthLinkClickEvent("".concat(siteName, "'s Privacy Statement."));
    };
    var handleEndUserTermsClick = function() {
        eventTracking === null || eventTracking === void 0 ? void 0 : eventTracking.trackAuthLinkClickEvent("".concat(siteName, "'s End User Terms."));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
        size: "sm",
        align: alignment,
        mt: "xxl",
        children: [
            "We are collecting your personal information in order to assist you with your home loan application or any other ancillary products. By clicking the '",
            buttonText,
            "' button you have read, consented and agreed to be bound by\xa0",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LinkWrapper, {
                href: privacyPolicyLink === null || privacyPolicyLink === void 0 ? void 0 : privacyPolicyLink.toString(),
                onClick: handlePrivacyPolicyClick,
                children: "".concat(siteName, "’s Privacy Statement")
            }),
            siteName === "Aussie" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    "\xa0and the\xa0",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LinkWrapper, {
                        href: "/about-us/property-end-terms/",
                        onClick: handleEndUserTermsClick,
                        children: "End User Terms"
                    })
                ]
            }),
            "."
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Disclaimer);


/***/ }),

/***/ 24940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports DividerWrapper, HorizontalLine, ORText */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56158);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90471);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 40%;\n  height: 0px;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  font-weight: bold;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var Divider = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DividerWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorizontalLine, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ORText, {
                children: "or"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorizontalLine, {})
        ]
    });
};
var DividerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-60a6c4da-0"
})(_templateObject(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_3__.my)("lg"));
var HorizontalLine = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    componentId: "sc-60a6c4da-1"
})(_templateObject1(), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.fg)("shade.100"));
var ORText = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-60a6c4da-2"
})(_templateObject2(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__/* .body */ .d1)({
    size: "md",
    color: "shade.400"
}));
/* harmony default export */ __webpack_exports__["ZP"] = (Divider);


/***/ }),

/***/ 42496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14258);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56158);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90471);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var EncriptionText = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(EncryptionTypeText, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                color: "shade.400"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
                ml: "xxxs",
                size: "xs",
                color: "shade.400",
                children: "256bit encryption"
            })
        ]
    });
};
var EncryptionTypeText = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4b23e28-0"
})(_templateObject(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_2__.my)("sm"));
/* harmony default export */ __webpack_exports__["Z"] = (EncriptionText);


/***/ }),

/***/ 51142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hr": function() { return /* binding */ AlertErrorSsi; },
/* harmony export */   "ne": function() { return /* binding */ AlertError; }
/* harmony export */ });
/* unused harmony export AlertWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71400);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56158);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90471);
/* harmony import */ var _state_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79826);
/* harmony import */ var _lendi_lala_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25980);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var renderDescription = function(description, brand) {
    if (!description) return null;
    var contactUsRegex = /contact us/gi;
    var parts = description.split(contactUsRegex);
    return parts.map(function(part, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                part,
                index < parts.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                    href: brand === _lendi_lala_react__WEBPACK_IMPORTED_MODULE_7__/* .Brand.Aussie */ .H2.Aussie ? "/get-in-touch" : "/contactus",
                    color: "error.500",
                    children: "contact us"
                })
            ]
        });
    });
};
var AlertError = function(param) {
    var error = param.error;
    var ref;
    var brand = (0,_lendi_lala_react__WEBPACK_IMPORTED_MODULE_7__/* .useSession */ .kP)().brand;
    return error && error.flow === _state_state__WEBPACK_IMPORTED_MODULE_6__/* .LALAAuthFlow.Passwordless */ .x1.Passwordless ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AlertWrapper, {
        variant: (error === null || error === void 0 ? void 0 : error.authError.errorLevel) || "error",
        heading: (error === null || error === void 0 ? void 0 : error.authError.alertHeading) || "",
        children: renderDescription(error === null || error === void 0 ? void 0 : (ref = error.authError) === null || ref === void 0 ? void 0 : ref.description, brand)
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
};
var AlertErrorSsi = function(param) {
    var error = param.error;
    var ref;
    var brand = (0,_lendi_lala_react__WEBPACK_IMPORTED_MODULE_7__/* .useSession */ .kP)().brand;
    return error && error.flow === _state_state__WEBPACK_IMPORTED_MODULE_6__/* .LALAAuthFlow.SSI */ .x1.SSI ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AlertWrapper, {
        variant: "error",
        children: renderDescription(error === null || error === void 0 ? void 0 : (ref = error.authError) === null || ref === void 0 ? void 0 : ref.description, brand)
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
};
var AlertWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_lendi_ui_alert__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-13078bf3-0"
})(_templateObject(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_3__.mb)("sm"));


/***/ }),

/***/ 38581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ GoogleSignInButton; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(44229);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(97939);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70111);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3541);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(89799);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(78645);
// EXTERNAL MODULE: ../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92712);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/fancy-icon/BtnGoogleLightNormalIos/dist/fancy-icon.esm.js
var fancy_icon_esm = __webpack_require__(91936);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/modal/dist/modal.esm.js
var modal_esm = __webpack_require__(67429);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/spacing/dist/spacing.esm.js
var spacing_esm = __webpack_require__(84209);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/spinner/dist/spinner.esm.js + 1 modules
var spinner_esm = __webpack_require__(75910);
// EXTERNAL MODULE: ../../../packages/lala-react/dist/esm/index.js + 318 modules
var esm = __webpack_require__(25980);
// EXTERNAL MODULE: ../node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(67921);
// EXTERNAL MODULE: ../node_modules/launchdarkly-react-client-sdk/lib/esm/index.js + 1 modules
var lib_esm = __webpack_require__(91649);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(90471);
// EXTERNAL MODULE: ../../../node_modules/uuid/index.js
var uuid = __webpack_require__(24819);
// EXTERNAL MODULE: ./state/actionProvider.tsx
var actionProvider = __webpack_require__(3842);
// EXTERNAL MODULE: ./state/state.ts
var state = __webpack_require__(79826);
// EXTERNAL MODULE: ./components/LightButton/index.tsx
var LightButton = __webpack_require__(4834);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/typography/dist/typography.esm.js
var typography_esm = __webpack_require__(56158);
;// CONCATENATED MODULE: ./components/SSIErrorModal/index.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 20rem;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9b279a06-0"
})(_templateObject(), (0,spacing_esm.px)("xs"));
// @ts-ignore
var HeadingWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Heading */.X6).withConfig({
    componentId: "sc-9b279a06-1"
})(_templateObject1());
var LinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Link */.rU).withConfig({
    componentId: "sc-9b279a06-2"
})(_templateObject2());

// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/fancy-icon/PageNotFound/dist/fancy-icon.esm.js
var dist_fancy_icon_esm = __webpack_require__(27155);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/button/dist/button.esm.js
var button_esm = __webpack_require__(22294);
;// CONCATENATED MODULE: ./components/SSIErrorModal/index.tsx







var SSIErrorModal = function(param) {
    var error = param.error, onCloseModal = param.onCloseModal;
    var ref = (0,actionProvider/* useActions */.ol)(), authorisePopup = ref.authorisePopup, resetError = ref.resetError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_fancy_icon_esm/* default */.Z, {
                height: "7.5em",
                width: "7.5em"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingWrapper, {
                color: "shade.700",
                size: "md",
                mt: "md",
                mb: "xs",
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_esm/* Body */.uT, {
                color: "shade.600",
                align: "center",
                mb: "md",
                children: [
                    "Sign in with Google did not work, please try again or let us know",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
                        href: "/contactus",
                        children: "[here]"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_esm/* Button */.zx, {
                variant: "primary",
                onClick: function() {
                    if (error) resetError();
                    onCloseModal();
                    authorisePopup("google-oauth2");
                },
                isFullWidth: true,
                children: "TRY AGAIN"
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/LaunchDarkly/index.tsx + 276 modules
var LaunchDarkly = __webpack_require__(56998);
;// CONCATENATED MODULE: ./components/GoogleSignInComponent/index.tsx







function GoogleSignInComponent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 6;\n  ",
        "\n  ",
        "\n"
    ]);
    GoogleSignInComponent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var ModalWrapper = (0,styled_components_browser_esm/* default */.ZP)(modal_esm/* default */.ZP).withConfig({
    componentId: "sc-924289c-0"
})(GoogleSignInComponent_templateObject(), (0,spacing_esm.px)("lg"), (0,spacing_esm.pb)("sm"));
var GoogleSignInButton = function(props) {
    var ref = (0,actionProvider/* useActions */.ol)(), authorisePopup = ref.authorisePopup, resetError = ref.resetError;
    var brand = (0,esm/* useSession */.kP)().brand;
    var ldClient = (0,lib_esm/* useLDClient */.mC)();
    var targetId = js_cookie.get("targetId") || (0,uuid.v4)();
    js_cookie.set("hasSSOAccessed", "true");
    var tracking = react.useContext(LaunchDarkly/* LDContext */.G).tracking;
    var eventTracking = (tracking || {}).eventTracking;
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        eventTracking === null || eventTracking === void 0 ? void 0 : eventTracking.trackAuthButtonClickEvent("SSO", "Sign in with Google", "secondary");
                        return [
                            4,
                            ldClient === null || ldClient === void 0 ? void 0 : ldClient.identify({
                                kind: "multi",
                                unauthUser: {
                                    key: targetId,
                                    isTeamView: false,
                                    hasSSOAccessed: true,
                                    brand: brand
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (props.error) resetError();
                        authorisePopup("google-oauth2");
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleButton, (0,_object_spread/* default */.Z)({
        onClick: handleClick
    }, props));
};
var GoogleButton = function(_param) {
    var error = _param.error, onClick = _param.onClick, verifying = _param.verifying, _children = _param.children, margin = (0,_object_without_properties/* default */.Z)(_param, [
        "error",
        "onClick",
        "verifying",
        "children"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), openModal = ref[0], setOpenModal = ref[1];
    react.useEffect(function() {
        if (error && error.flow === state/* LALAAuthFlow.SSI */.x1.SSI) {
            setOpenModal(true);
        } else {
            setOpenModal(false);
        }
    }, [
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightButton/* LightButton */.a, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "secondary",
                isFullWidth: true,
                isDisabled: verifying,
                onClick: onClick
            }, margin), {
                before: /*#__PURE__*/ (0,jsx_runtime.jsx)(fancy_icon_esm/* default */.Z, {
                    width: "3.5em",
                    height: "3.5em"
                }),
                children: verifying ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_esm/* default */.Z, {
                    variant: "dark"
                }) : "Sign in with Google"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWrapper, {
                isVisible: openModal,
                size: "md",
                onHide: function() {
                    return setOpenModal(!openModal);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_esm/* default.Content */.ZP.Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SSIErrorModal, {
                        error: error,
                        onCloseModal: function() {
                            return setOpenModal(false);
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var GoogleSignInComponent = ((/* unused pure expression or super */ null && (GoogleButton)));


/***/ }),

/***/ 4834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ LightButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var _lendi_ui_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22294);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90471);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    border-color: ",
        ";\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// @ts-ignore
var LightButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_lendi_ui_button__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx).withConfig({
    componentId: "sc-87bc0380-0"
})(_templateObject(), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$)("shade.200"), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.bg)("shade.0"), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.fg)("shade.700"));


/***/ }),

/***/ 18457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ setPrlAndReferralParamsToStorage; }
});

// EXTERNAL MODULE: ../../../packages/lala-utils/dist/esm/index.js + 23 modules
var esm = __webpack_require__(82839);
;// CONCATENATED MODULE: ./helpers/getParamFromReturnUrl.ts
var ParamName;
(function(ParamName) {
    ParamName["StoreId"] = "storeid";
    ParamName["BrokerId"] = "brokerid";
})(ParamName || (ParamName = {}));
var getParamFromReturnUrl = function(params, paramName) {
    var returnUrlParam = params.get("returnurl");
    if (!returnUrlParam) return null;
    var index = returnUrlParam.indexOf("?");
    if (index === -1) return null;
    var returnUrlParams = new URLSearchParams(returnUrlParam.substring(index + 1));
    var brokerIdFromReturnUrl = returnUrlParams.get(paramName);
    return brokerIdFromReturnUrl;
};

;// CONCATENATED MODULE: ./helpers/setPrlAndReferralParamsToStorage.ts


function setPrlAndReferralParamsToStorage() {
    var ref;
    var params = new URLSearchParams((ref = window.location.search) === null || ref === void 0 ? void 0 : ref.toLowerCase());
    var storeIdFromLocalStorage = localStorage.getItem(esm/* PRL_STORE_ID */.Rj);
    var brokerIdFromLocalStorage = localStorage.getItem(esm/* PRL_BROKER_ID */.Gz);
    var refCodeFromLocalStorage = localStorage.getItem(esm/* CUSTOMER_REFERRAL_CODE */.TX);
    var companyGenFromLocalStorage = localStorage.getItem(esm/* PRL_COMPANY_GEN */.$I);
    var campaignNameFromLocalStorage = localStorage.getItem(esm/* PRL_CAMPAIGN_NAME */.E4);
    var isParamSet = storeIdFromLocalStorage || brokerIdFromLocalStorage || refCodeFromLocalStorage || companyGenFromLocalStorage || campaignNameFromLocalStorage;
    if (!isParamSet) {
        var storeId = params.get("storeid") || getParamFromReturnUrl(params, ParamName.StoreId);
        if (storeId) {
            localStorage.setItem(esm/* PRL_STORE_ID */.Rj, storeId);
        }
        var brokerId = params.get("brokerid") || getParamFromReturnUrl(params, ParamName.BrokerId);
        if (brokerId) {
            localStorage.setItem(esm/* PRL_BROKER_ID */.Gz, brokerId);
        }
        var refCode = params.get("refcode");
        if (refCode) {
            localStorage.setItem(esm/* CUSTOMER_REFERRAL_CODE */.TX, refCode);
        }
        var companyGen = params.get("cgen");
        if (companyGen) {
            localStorage.setItem(esm/* PRL_COMPANY_GEN */.$I, companyGen);
        }
        var campaignName = params.get("cname");
        if (campaignName) {
            localStorage.setItem(esm/* PRL_CAMPAIGN_NAME */.E4, campaignName);
        }
    }
}


/***/ }),

/***/ 29580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bt": function() { return /* binding */ AuthForm; },
/* harmony export */   "En": function() { return /* binding */ BenefitsUnit; },
/* harmony export */   "GL": function() { return /* binding */ BeforeWrapper; },
/* harmony export */   "NL": function() { return /* binding */ Prompt; },
/* harmony export */   "Om": function() { return /* binding */ NoBr; },
/* harmony export */   "WR": function() { return /* binding */ DivMBSM; },
/* harmony export */   "Z0": function() { return /* binding */ Separator; },
/* harmony export */   "_U": function() { return /* binding */ MainContentWrapper; },
/* harmony export */   "dx": function() { return /* binding */ PromptHeader; },
/* harmony export */   "eX": function() { return /* binding */ Actions; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "jn": function() { return /* binding */ RFFFieldWrapper; },
/* harmony export */   "wC": function() { return /* binding */ PromptMessage; },
/* harmony export */   "zL": function() { return /* binding */ YesNoButton; }
/* harmony export */ });
/* unused harmony exports ContentUnit, ExpiredUnit, CardWrapper, DefaultLoginWrapper, LoginVariantWrapper, LoginVariantContainer, ExtraContainer, StyledRequestCode, Content, Heading, SubHeading, Mainpage, ContentWrapper, AlertWrapper, WordWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78645);
/* harmony import */ var _lendi_ui_alert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71400);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23783);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62792);
/* harmony import */ var _lendi_ui_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58905);
/* harmony import */ var _lendi_ui_depth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12987);
/* harmony import */ var _lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63518);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56158);
/* harmony import */ var _lendi_ui_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27233);
/* harmony import */ var _lendi_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87190);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90471);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  height: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  position: absolute;\n  width: 250px;\n  right: 0;\n  top: calc(2.5 * var(--lendi-ui-size));\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 978px;\n  margin: 0 auto;\n  display: flex;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n    justify-content: space-evenly;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  display: flex;\n  justify-content: space-around;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.14;\n  letter-spacing: normal;\n  text-align: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  line-height: 1.38;\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-top: calc(-4 * var(--lendi-ui-size));\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  position: relative;\n  margin-top: calc(-2 * var(--lendi-ui-size));\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  ",
        "\n  ",
        "\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 320px;\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  margin: auto;\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  border: none;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 64px;\n  background: var(--background-page, #f8f8f8);\n  color: var(--text-main, #474747);\n  font-style: normal;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 553px;\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 90%;\n  ",
        "\n  padding: 20px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  border-radius: 6px;\n  background: var(--background-container, #fff);\n  ",
        ";\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n  font-weight: 400;\n  font-size: 24.5px;\n  line-height: 28.17px;\n  text-align: center;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: auto;\n    flex-direction: row;\n  "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  width: 100%;\n  flex-direction: column;\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 212px;\n  "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  display: flex;\n  width: 100%;\n  height: 48px;\n  padding: 0px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  > span {\n    font-size: 14px;\n    line-height: 14px;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n  }\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}











// @ts-ignore
var ContentUnit = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-0"
})(_templateObject(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 1 / 2
    }
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.px)({
    mobile: "sm",
    tablet: "md"
}));
var ExpiredUnit = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-1"
})(_templateObject1(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 1 / 2
    }
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.px)({
    mobile: "sm",
    tablet: "md"
}));
var BenefitsUnit = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Unit */ .ZP.Unit).withConfig({
    componentId: "sc-29f87150-2"
})(_templateObject3(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("lg")(_templateObject2()));
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-3"
})(_templateObject4(), _lendi_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .container */ .n);
var CardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-4"
})(_templateObject5(), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_8__/* .display */ .jf)({
    mobile: "none",
    desktop: "block"
}));
// Default Sign in
var DefaultLoginWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-5"
})(_templateObject6());
// For AB testing we could have variants, this is the wrapper for that.
var LoginVariantWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-6"
})(_templateObject8(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: 1
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("md"), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject7(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("lg")));
// Left side variant
var LoginVariantContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-7"
})(_templateObject9(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 0.9,
        tablet: 3 / 8,
        desktop: 6 / 16
    },
    offset: {
        mobile: 0,
        tablet: 0,
        desktop: 2 / 16
    }
}));
// Right side variant
var ExtraContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-8"
})(_templateObject10(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        tablet: 3.5 / 8,
        desktop: 7 / 16
    },
    offset: {
        tablet: 0,
        desktop: 1 / 16
    }
}), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_8__/* .display */ .jf)({
    mobile: "none",
    tablet: "inherit"
}));
var StyledRequestCode = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-9"
})(_templateObject11(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1
    }
}));
var Content = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-10"
})(_templateObject12(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 0.9,
        desktop: 0.6
    }
}));
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-11"
})(_templateObject13(), (0,_lendi_ui_grid__WEBPACK_IMPORTED_MODULE_5__/* .unit */ .bf)({
    size: {
        mobile: 1,
        tablet: 0.9,
        desktop: 0.7
    }
}), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .heading */ .nP)({
    size: "md",
    color: "shade.800"
}));
var SubHeading = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-12"
})(_templateObject14(), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .body */ .d1)({
    size: "md",
    color: "shade.700"
}), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("lg"));
var Mainpage = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-13"
})(_templateObject16(), _lendi_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .container */ .n, (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("desktop")(_templateObject15()));
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-14"
})(_templateObject18(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .between */ .vX)("mobile", "tablet")(_templateObject17(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mx)("xs")));
var BeforeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-29f87150-15"
})(_templateObject19(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.ml)("sm"), (0,_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .body */ .d1)({
    size: "lg",
    color: "shade.500"
}));
var AlertWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-29f87150-16"
})(_templateObject20(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mb)("sm"));
var RFFFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-17"
})(_templateObject21(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mb)("sm"));
var WordWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-29f87150-18"
})(_templateObject22());
var NoBr = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-29f87150-19"
})(_templateObject23());
var AuthForm = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-29f87150-20"
})(_templateObject25(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject24()));
var DivMBSM = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-21"
})(_templateObject26(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.mb)("sm"));
var Separator = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    componentId: "sc-29f87150-22"
})(_templateObject27(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__.my)("lg"), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$)("shade.200"));
var MainContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-23"
})(_templateObject28());
var Prompt = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-24"
})(_templateObject30(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject29()), (0,_lendi_ui_depth__WEBPACK_IMPORTED_MODULE_11__/* .depth */ .Y)(1));
// @ts-ignore
var PromptHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Heading */ .X6).withConfig({
    componentId: "sc-29f87150-25"
})(_templateObject31());
var PromptMessage = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT).withConfig({
    componentId: "sc-29f87150-26"
})(_templateObject32());
var Actions = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29f87150-27"
})(_templateObject34(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject33()));
var YesNoButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_lendi_ui__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx).withConfig({
    componentId: "sc-29f87150-28"
})(_templateObject36(), (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .gte */ .eg)("tablet")(_templateObject35()));


/***/ })

}]);